module.exports = __webpack_public_path__ + "img/undertakingCases27.cf1bca16.png";